
export { ErrorCode } from "./constants/lingoError"
export { isError } from "./constants/lingoError"